import { useGetProductByIdQuery } from "client/graphql/commerce-v2-api"

import { getProductVariantFromProduct } from "../components/selectors"

export default function useVariantFromCache(
  productId?: string | null,
  variantId?: string | null,
) {
  const result = useGetProductByIdQuery(
    productId
      ? {
          variables: {
            id: productId,
          },
          fetchPolicy: "cache-first",
        }
      : {
          skip: true,
        },
  )

  return [
    getProductVariantFromProduct(
      variantId,
      result.data?.instance.activeSale.product,
    ),
    result,
  ] as const
}
